import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { REPORTS_ROUTES } from './reports.routes';
import { ReportService } from './shared/report.service';
import { ReportsComponent } from './reports.component';
import { ReportConfigurationComponent } from './reports-configuration/report-configuration.component';
import { ReportFormComponent } from './report-form/report-form.component';
import { ReportOverviewComponent } from './report-overview/report-overview.component';
import { AssetListComponent } from './asset-list/asset-list.component';
import { UserRoleBadgeComponent } from './user-role-badge/user-role-badge.component';

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(REPORTS_ROUTES)
    ],
    declarations: [
        AssetListComponent,
        ReportsComponent,
        ReportConfigurationComponent,
        ReportFormComponent,
        ReportOverviewComponent,
        UserRoleBadgeComponent,
    ],
    exports: [
        UserRoleBadgeComponent
    ],
    providers: [
        ReportService
    ]
})

export class ReportsModule {
}
